import { colors } from "~/styles/theme";

export const highlightColors = [
  colors.yellow100,
  colors.rose100,
  colors.blue200,
  colors.green200,
];
